import React from 'react';
import LegalPageShell from '../components/LegalPageShell';
import LEGAL_DETAILS from '../config/legal';
import SEO from '../components/SEO';
import { SEO_TEXTES } from '../data/seoTextes';

const userCommitments = [
  "fournir des informations exactes lors de la connexion et de l'utilisation des services",
  "pr\u00e9server la confidentialit\u00e9 de ses moyens d'acc\u00e8s",
  "utiliser l'application dans le respect des lois et r\u00e8glements applicables",
];

const editorDetails = [
  { label: 'Soci\u00e9t\u00e9', value: LEGAL_DETAILS.companyName },
  { label: 'Email', value: LEGAL_DETAILS.contactEmail },
  { label: 'Site web', value: LEGAL_DETAILS.website },
];

function BulletList({ items }) {
  return (
    <ul className="space-y-3">
      {items.map((item) => (
        <li key={item} className="flex gap-3 text-slate-300 leading-relaxed">
          <span className="mt-2 h-2 w-2 rounded-full bg-[#0099D6] flex-shrink-0" />
          <span>{item}</span>
        </li>
      ))}
    </ul>
  );
}

function DetailList({ items }) {
  return (
    <dl className="space-y-4">
      {items.map((item) => (
        <div key={item.label} className="border-b border-white/5 pb-4 last:border-b-0 last:pb-0">
          <dt className="text-sm uppercase tracking-[0.18em] text-slate-500 mb-1">{item.label}</dt>
          <dd className="text-base text-slate-200">{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}

export default function LegalMentions() {
  return (
    <>
      <SEO {...SEO_TEXTES['/mentions-legales']} path="/mentions-legales" />
    <LegalPageShell
      testId="legal-mentions-page"
      title={"Mentions l\u00e9gales et conditions d'utilisation"}
      subtitle={"L'application METERIS permet l'acc\u00e8s \u00e0 certains services en ligne propos\u00e9s par METERIS dans un cadre professionnel, s\u00e9curis\u00e9 et r\u00e9serv\u00e9 aux utilisateurs autoris\u00e9s."}
      updatedAt={LEGAL_DETAILS.updatedAt.terms}
    >
      <div className="grid gap-6 lg:grid-cols-[minmax(0,1.2fr)_minmax(280px,0.8fr)]">
        <section className="rounded-3xl border border-white/5 bg-[#15171E]/70 p-8 md:p-10">
          <h2 className="text-2xl font-semibold text-white mb-4">Objet</h2>
          <p className="text-slate-300 leading-relaxed">
            {"L'application donne acc\u00e8s \u00e0 des services, portails et outils en ligne propos\u00e9s par METERIS. Son utilisation suppose un usage conforme \u00e0 sa finalit\u00e9 et r\u00e9serv\u00e9 aux personnes autoris\u00e9es."}
          </p>
        </section>

        <aside className="rounded-3xl border border-white/5 bg-[#0F1117]/90 p-8 md:p-10">
          <h2 className="text-2xl font-semibold text-white mb-4">{'\u00c9diteur'}</h2>
          <DetailList items={editorDetails} />
        </aside>
      </div>

      <div className="grid gap-6 lg:grid-cols-2">
        <section className="rounded-3xl border border-white/5 bg-[#15171E]/70 p-8 md:p-10">
          <h2 className="text-2xl font-semibold text-white mb-4">{'Engagements de l\u2019utilisateur'}</h2>
          <BulletList items={userCommitments} />
        </section>

        <section className="rounded-3xl border border-white/5 bg-[#15171E]/70 p-8 md:p-10">
          <h2 className="text-2xl font-semibold text-white mb-4">{'Acc\u00e8s et s\u00e9curit\u00e9'}</h2>
          <p className="text-slate-300 leading-relaxed">
            {'METERIS peut suspendre ou limiter l\u2019acc\u00e8s en cas d\u2019usage abusif, frauduleux, non autoris\u00e9 ou de risque pour la s\u00e9curit\u00e9 des services ou des utilisateurs.'}
          </p>
        </section>
      </div>

      <div className="grid gap-6 lg:grid-cols-2">
        <section className="rounded-3xl border border-white/5 bg-[#15171E]/70 p-8 md:p-10">
          <h2 className="text-2xl font-semibold text-white mb-4">{'\u00c9volution des services'}</h2>
          <p className="text-slate-300 leading-relaxed">
            {'Les services accessibles via l\u2019application peuvent \u00e9voluer, \u00eatre modifi\u00e9s ou \u00eatre interrompus sans garantie absolue de disponibilit\u00e9 permanente. METERIS s\u2019efforce toutefois de maintenir un niveau de service raisonnable et adapt\u00e9 \u00e0 ses contraintes techniques et organisationnelles.'}
          </p>
        </section>

        <section className="rounded-3xl border border-white/5 bg-[#15171E]/70 p-8 md:p-10">
          <h2 className="text-2xl font-semibold text-white mb-4">{'Limitation de responsabilit\u00e9'}</h2>
          <p className="text-slate-300 leading-relaxed">
            {'METERIS ne pourra pas \u00eatre tenue responsable des dommages r\u00e9sultant d\u2019une utilisation non conforme, d\u2019une indisponibilit\u00e9 temporaire raisonnable, d\u2019un incident technique ext\u00e9rieur \u00e0 son contr\u00f4le ou d\u2019un manquement de l\u2019utilisateur \u00e0 ses propres obligations de s\u00e9curit\u00e9.'}
          </p>
        </section>
      </div>

      <section className="rounded-3xl border border-white/5 bg-[#0F1117]/90 p-8 md:p-10">
        <h2 className="text-2xl font-semibold text-white mb-4">Acceptation et contact</h2>
        <p className="text-slate-300 leading-relaxed mb-4">
          {"L'utilisation de l'application implique l'acceptation des pr\u00e9sentes conditions d'utilisation."}
        </p>
        <p className="text-slate-300 leading-relaxed">
          {'Pour toute question relative \u00e0 ces mentions l\u00e9gales ou aux conditions d\u2019utilisation, vous pouvez contacter METERIS \u00e0 l\u2019adresse suivante : '}
          <span className="text-slate-100 font-medium">{LEGAL_DETAILS.contactEmail}</span>
        </p>
      </section>
    </LegalPageShell>
    </>
  );
}
